module.exports = __webpack_public_path__ + "static/media/demo.a4808125.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/demo.pdf
// module id = 356
// module chunks = 2